import VesselColour from "../Enums/VesselColour";

const ColorHelper = {};

ColorHelper.rgbToHex = (r, g, b) => "#" + [r, g, b].map(x => {
	const hex = x.toString(16);
	return hex.length === 1 ? "0" + hex : hex;
}).join("");

ColorHelper.hexToRgb = hex =>
	hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
		, (m, r, g, b) => "#" + r + r + g + g + b + b)
		.substring(1).match(/.{2}/g)
		.map(x => parseInt(x, 16));

// TODO: get the rest of the colour values - make map function VesselColor -> hex.
ColorHelper.getRiskLevelColor = (risklevel) => {
	return ColorHelper.vesselColorToHex(ColorHelper.getRiskLevelVesselColor(risklevel));
};
ColorHelper.getRiskLevelVesselColor = (risklevel) => {
	const data = {
		0: VesselColour.WHITE,
		1: VesselColour.GRAY,
		2: VesselColour.LIGHTGREEN,
		3: VesselColour.YELLOW,
		4: VesselColour.ORANGE,
		5: VesselColour.LIGHTRED
	};
	return data[risklevel];
};
ColorHelper.vesselColorToHex = (vesselColor) => {
	const map = {
		[VesselColour.BLACK]: "#000000",
		[VesselColour.BROWN]: "#9c5900",
		[VesselColour.DARKBLUE]: "#2500d0",
		[VesselColour.DARKGREEN]: "#006a38",
		[VesselColour.DARKRED]: "#cc0040",
		[VesselColour.GRAY]: "#969696",
		[VesselColour.LIGHTBLUE]: "#156fff",
		[VesselColour.LIGHTGREEN]: "#1baa36",
		[VesselColour.LIGHTRED]: "#ff0000",
		[VesselColour.MAGENTA]: "#ff15b8",
		[VesselColour.ORANGE]: "#ff7c1b",
		[VesselColour.PURPLE]: "#b30ad8",
		[VesselColour.SALMON]: "#ff9a98",
		[VesselColour.VIOLET]: "#d68fff",
		[VesselColour.YELLOW]: "#e9dc00",
		[VesselColour.WHITE]: "#ffffff"
	};
	return map[vesselColor];
};
export default ColorHelper;
